
/**
 * プログラム中で動的に生成されるディレクティブをAngularで生成する
 * https://stackoverflow.com/questions/20025526/angularjs-dynamically-creating-elements-that-specify-directives
 * @param {string} html 
 * @param {element} parentElement 
 * @returns created element
 */
export default (html, parentElement) => {
  const element = angular.element(html);
  const compiler = angular.element(document.body)//angular.element(parentElement);
  const $compile = compiler.injector().get('$compile');
  angular.element(parentElement).append(element);//こっちを↓より後に回すと極遅になる
  $compile(element)(compiler.scope())// $compile(element)(pa.scope());
  return element;
}